import Vue from 'vue'

import translit from'./translit'
Vue.prototype.$ = {
    translit
};